import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'

export default {
  async getHistoryOrders ({ rootState, commit, rootGetters }) {
    const { data: orders } = await storeClient.get(`stores/${rootGetters.storeId}/orderHistory`, {
      headers: { 'If-None-Match': '' }
    })
    commit(types.SET_ORDER_LIST, orders)
  },
  updateOrder ({ commit }, order) {
    commit(types.UPDATE_ORDER, order)
  },
  setFilterConfig ({ commit }, filterConfig) {
    commit(types.SET_FILTER_CONFIG, filterConfig)
  }
}
